module.exports = __webpack_public_path__ + "img/6_6.3a4093df.png";